import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Page, ToggleComponent } from '@serpro/ngx-suite-rfb';
import { isEmpty } from 'lodash';
import { map } from 'rxjs/operators';
import { Composicao } from 'src/app/pagamento/models/composicao';
import { Pagamento } from 'src/app/pagamento/models/pagamento';
import { PagamentoService } from 'src/app/pagamento/services/pagamento.service';
import { ScopedMessageService } from 'src/app/shared/services/scoped-message.service';

@Component({
  selector: 'composicao-detalhes',
  templateUrl: './composicao-detalhes.component.html',
  styleUrls: ['./composicao-detalhes.component.css'],
  providers: [ScopedMessageService]
})
export class ComposicaoDetalhesComponent implements OnInit {
  @Input() public pagamento: Pagamento;
  @Input() public collapsed: boolean = true;

  @ViewChildren("detalhes") public detalhesQuery: QueryList<ToggleComponent>;

  public composicoes: Composicao[];
  public codigoPrincipal: string;
  public codigoMulta: string;
  public codigoJuros: string;
  public codigoEncargo: string;
  public scopeId: string;
  public initError: boolean;

  public pageSize: number = 10;
  public currentPage: Page = {
    number: 1,
    first: 0,
    last: this.pageSize
  };

  constructor(
    private pagamentoService: PagamentoService,
    private scopedMessageService: ScopedMessageService,
  ) { }

  public ngOnInit(): void {
    this.onCollapsedChange(this.collapsed);
    this.scopeId = this.scopedMessageService.scopeId;
  }

  public onCollapsedChange(collapsed: boolean): void {
    this.collapsed = collapsed;

    if (this.collapsed || this.composicoes != null) {
      return null;
    }

    this.carregarComposicoes();
  }

  public expandeTodosDetalhes(show: boolean): void {
    this.detalhesQuery.forEach(detalhe => {
      detalhe.show = show;
    });
  }

  private carregarComposicoes(): void {
    this.pagamentoService.obterDadosDeComposicao(this.pagamento.pgtoNr).pipe(map((r) => r.map((d) => new Composicao(d))))
      .subscribe({
        next: (composicoes: Composicao[]) => {
          if (isEmpty(composicoes)) {
            this.scopedMessageService.showInfo('Nenhum registro encontrado');
            this.initError = true;
          }

          this.composicoes = composicoes;
        },
        error: () => {
          this.scopedMessageService.showError('Ocorreu um erro na consulta de dados da composição');
          this.initError = true;
        }
      });
  }
}
